import { DocumentService } from '@core/services/DocumentService';

export async function list_formatter(data) {
  const documents_with_preview = data.map(set_preview_and_download_info);
  await Promise.all(documents_with_preview);
  return data;
}
const check_file_type = document => {
  const { extension } = document;
  if (!extension) {
    return false;
  }
  const accepted_types = ['png', 'gif', 'jpeg', 'jpg'];
  return accepted_types.includes(extension);
};
const set_download_info = document => {
  const { id, extension } = document;
  document.filename = `document_${id}.${extension}`;
  return document;
};
const set_preview_info = document => {
  document.is_preview = check_file_type(document);
  return document;
};

async function set_preview_and_download_info(document) {
  const base64 = await DocumentService.getBase64(document.id);
  if (base64) {
    document.base64 = base64;
    document = set_preview_info(document);
    document = set_download_info(document);
  }
  return document;
}
